/* eslint-disable import/prefer-default-export,no-restricted-globals */

export function open(url, title, w, h) {
  const left = window.screenX + screen.width / 2 - w / 2;
  const top = window.screenY + screen.height / 2 - h / 2;

  return window.open(url, title, `width=${w}, height=${h}, top=${top}, left=${left}`);
}



// WEBPACK FOOTER //
// ./utils/popupWindow.js